const TEXT_FIELDS =
  'textarea, input:not([type]), input[type="text"], input[type="search"], input[type="email"], input[type="url"], input[type="tel"], input[type="number"]';

/**
 * Whether the page holds text the user typed and could lose on a reload:
 * a non-empty text field or rich-text editor. Errs on the side of "yes" — a
 * filled search box counts too.
 */
export const hasUnsavedInput = (root: ParentNode): boolean => {
  const fields = root.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>(
    TEXT_FIELDS
  );
  for (const field of fields) {
    if (field.value.trim() !== "") return true;
  }

  const editors = root.querySelectorAll<HTMLElement>('[contenteditable="true"]');
  for (const editor of editors) {
    if ((editor.textContent ?? "").trim() !== "") return true;
  }

  return false;
};
